<template>
    <div>
        <div class="grid-container">
            <div :class="{ 'content': !expanded, 'content expandedText': expanded }"  style="white-space: pre-line;">
                {{text}}<br><br>
                <span @click="expandText" class="expandButton">{{ expanded ? showLess : showMore }}</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        lang: {
            type: String, required: true
        },
        text: {
            type: String,
            required: false,
            default: (
                " views  " +
                "Premiered 17 hours ago  Candace Owens Podcast" +
                "I break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”" +

                "Ep.305" +

                "- - - " +

                "Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPL" +

                "Grab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y " +

                "- - - " +
                "A> views Premiered 17 hours ago Candace Owens PodcastI break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”Ep.305- - - Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expressvpn.com/candaceGrand Canyon University - Find your purpose at Grand Canyon University: https://www.gcu.edu/Balance of Nature - Get 35% off Your Order of Fruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/#CandaceOwens #News #Politics #Culture #PopCulture #dailywire - - - 00:00 - Start01:00 - Your feedback on my interview with Rabbi Barclay04:36 - My history in politics14:44 - Kanye’s tweet and my response21:10 - Commentary on the Israel/Palestine conflict29:50 - The articles written to smear me34:00 - My voice will not be controlled views Premiered 17 hours ago Candace Owens PodcastI break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”Ep.305- - - Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expressvpn.com/candaceGrand Canyon University - Find your purpose at Grand Canyon University: https://www.gcu.edu/Balance of Nature - Get 35% off Your Order of Fruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/#CandaceOwens #News #Politics #Culture #PopCulture #dailywire - - - 00:00 - Start01:00 - Your feedback on my interview with Rabbi Barclay04:36 - My history in politics14:44 - Kanye’s tweet and my response21:10 - Commentary on the Israel/Palestine conflict29:50 - The articles written to smear me34:00 - My voice will not be controlled views Premiered 17 hours ago Candace Owens PodcastI break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”Ep.305- - - Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expressvpn.com/candaceGrand Canyon University - Find your purpose at Grand Canyon University: https://www.gcu.edu/Balance of Nature - Get 35% off Your Order of Fruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/#CandaceOwens #News #Politics #Culture #PopCulture #dailywire - - - 00:00 - Start01:00 - Your feedback on my interview with Rabbi Barclay04:36 - My history in politics14:44 - Kanye’s tweet and my response21:10 - Commentary on the Israel/Palestine conflict29:50 - The articles written to smear me34:00 - My voice will not be controlled> views Premiered 17 hours ago Candace Owens PodcastI break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”Ep.305- - - Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expressvpn.com/candaceGrand Canyon University - Find your purpose at Grand Canyon University: https://www.gcu.edu/Balance of Nature - Get 35% off Your Order of Fruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/#CandaceOwens #News #Politics #Culture #PopCulture #dailywire - - - 00:00 - Start01:00 - Your feedback on my interview with Rabbi Barclay04:36 - My history in politics14:44 - Kanye’s tweet and my response21:10 - Commentary on the Israel/Palestine conflict29:50 - The articles written to smear me34:00 - My voice will not be controlled views Premiered 17 hours ago Candace Owens PodcastI break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”Ep.305- - - Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expressvpn.com/candaceGrand Canyon University - Find your purpose at Grand Canyon University: https://www.gcu.edu/Balance of Nature - Get 35% off Your Order of Fruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/#CandaceOwens #News #Politics #Culture #PopCulture #dailywire - - - 00:00 - Start01:00 - Your feedback on my interview with Rabbi Barclay04:36 - My history in politics14:44 - Kanye’s tweet and my response21:10 - Commentary on the Israel/Palestine conflict29:50 - The articles written to smear me34:00 - My voice will not be controlled views Premiered 17 hours ago Candace Owens PodcastI break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”Ep.305- - - Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expressvpn.com/candaceGrand Canyon University - Find your purpose at Grand Canyon University: https://www.gcu.edu/Balance of Nature - Get 35% off Your Order of Fruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/#CandaceOwens #News #Politics #Culture #PopCulture #dailywire - - - 00:00 - Start01:00 - Your feedback on my interview with Rabbi Barclay04:36 - My history in politics14:44 - Kanye’s tweet and my response21:10 - Commentary on the Israel/Palestine conflict29:50 - The articles written to smear me34:00 - My voice will not be controlled> views Premiered 17 hours ago Candace Owens PodcastI break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”Ep.305- - - Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expressvpn.com/candaceGrand Canyon University - Find your purpose at Grand Canyon University: https://www.gcu.edu/Balance of Nature - Get 35% off Your Order of Fruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/#CandaceOwens #News #Politics #Culture #PopCulture #dailywire - - - 00:00 - Start01:00 - Your feedback on my interview with Rabbi Barclay04:36 - My history in politics14:44 - Kanye’s tweet and my response21:10 - Commentary on the Israel/Palestine conflict29:50 - The articles written to smear me34:00 - My voice will not be controlled views Premiered 17 hours ago Candace Owens PodcastI break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”Ep.305- - - Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expressvpn.com/candaceGrand Canyon University - Find your purpose at Grand Canyon University: https://www.gcu.edu/Balance of Nature - Get 35% off Your Order of Fruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/#CandaceOwens #News #Politics #Culture #PopCulture #dailywire - - - 00:00 - Start01:00 - Your feedback on my interview with Rabbi Barclay04:36 - My history in politics14:44 - Kanye’s tweet and my response21:10 - Commentary on the Israel/Palestine conflict29:50 - The articles written to smear me34:00 - My voice will not be controlled views Premiered 17 hours ago Candace Owens PodcastI break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”Ep.305- - - Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expressvpn.com/candaceGrand Canyon University - Find your purpose at Grand Canyon University: https://www.gcu.edu/Balance of Nature - Get 35% off Your Order of Fruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/#CandaceOwens #News #Politics #Culture #PopCulture #dFruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/#CandaceOwens #News #Politics #Culture #PopCulture #dailywire - - - 00:00 - Start01:00 - Your feedback on my interview with Rabbi Barclay04:36 - My history in politics14:44 - Kanye’s tweet and my response21:10 - Commentary on the Israel/Palestine conflict29:50 - The articles written to smear me34:00 - My voice will not be controlled views Premiered 17 hours ago Candace Owens PodcastI break down all the new and old media attacks I’ve received for things I never said and ask the question, “What is the point of all this?”Ep.305- - - Binge ALL 10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expr10 episodes of Convicting a Murderer here: https://bit.ly/3RbWBPLGrab some “Yes We CANdace” merch here: https://bit.ly/3Amm13Y - - - Today’s Sponsors:ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expr" +
                "Today’s Sponsors:" +

                "ExpressVPN - Get 3 Months FREE of ExpressVPN: https://www.expressvpn.com/candace" +

                "Grand Canyon University - Find your purpose at Grand Canyon University: https://www.gcu.edu/" +

                "Balance of Nature - Get 35% off Your Order of Fruits & Veggies + $10 Off Every Additional Set. Use promo code CANDACE at checkout: https://www.balanceofnature.com/" +

                "#CandaceOwens #News #Politics #Culture #PopCulture #dailywire " +
                "- - - " +
                "00:00 - Start" +
                "01:00 - Your feedback on my interview with Rabbi Barclay" +
                "04:36 - My history in politics" +
                "14:44 - Kanye’s tweet and my response" +
                "21:10 - Commentary on the Israel/Palestine conflict" +
                "29:50 - The articles written to smear me" +
                "34:00 - My voice will not be controlled" +
                "42:40 - I am Team God.xxx"
            ),
        }

    },
    data() {
        return {
            showMore: null,
            showLess: null,
            showContent: false,
            containerHeight: '0px',
            expanded: false,
            // maxLines: 3, // Change this value to the number of lines you want to initially display
            // limitedTextHeight: 0
        };
    },
    mounted() {
        this.initStuff();


        console.log("ShowMoreText.vue", "mounted");
    },
    beforeUpdate() {

        this.initStuff();
        console.log("ShowMoreText.vue", "beforeUpdate");


    },
    // computed: {
    //     limitedText() {
    //         // Split large text into lines and take the first `maxLines` lines
    //         return this.largeText.split('\n').slice(0, this.maxLines).join('\n');
    //     }
    // },
    methods: {
        
parseISO8601Full(durationString) {


// Example usage:
// const durationString = "P1Y2M3W4DT5H6M7S";
// const totalSeconds = parseDuration(durationString);
// console.log(totalSeconds); // Output: 37211867 seconds




// Use regular expressions to extract years, months, weeks, days, hours, minutes, and seconds
const regex = /P(?:([-+]?\d+Y)?([-+]?\d+M)?([-+]?\d+W)?([-+]?\d+D)?)?(T(?:([-+]?\d+H)?([-+]?\d+M)?([-+]?\d+S)?)?)?/;
const matches = durationString.match(regex);

// Extract years, months, weeks, days, hours, minutes, and seconds from the matches
const years = parseInt(matches[1] || 0, 10);
const months = parseInt(matches[2] || 0, 10);
const weeks = parseInt(matches[3] || 0, 10);
const days = parseInt(matches[4] || 0, 10);
const hours = parseInt(matches[6] || 0, 10);
const minutes = parseInt(matches[7] || 0, 10);
const seconds = parseInt(matches[8] || 0, 10);

// Calculate total duration in seconds
const totalSeconds = (years * 31536000) + (months * 2592000) + (weeks * 604800) + (days * 86400) + (hours * 3600) + (minutes * 60) + seconds;

// let ifValueThenMagic=function(t,padZero)
// { 
//   if(t===0)
//   return false;

//   return true;
// }

// let str="";
// str+= (years>=0? (years+ " years") :"");


// str=""(seconds>=0?"":"");

var buildStr=function(str, val)
{

  let s="";

  if(val===0)
  {
    s=""
  }
  else if(val===1)
  {
    s=val + " " +str.slice(0, -1) +", ";
  }
  else
  {
    s=val + " " +str +", ";
  }

  return s;
}

let str="";
str+=buildStr("years",years);
str+=buildStr("months",months);
str+=buildStr("weeks",weeks);
str+=buildStr("days",days);
str+=buildStr("hours",hours);
str+=buildStr("mins",minutes);
str+=buildStr("secs",seconds);

str+=str.slice(0, -1);


return {
totalSeconds: totalSeconds,
seconds: seconds,
minutes: minutes,
hours:hours,
days:days,
weeks:weeks,
months:months,
years:years,
deliciousString:str,

};

},


        textCdata() {
            return "<![CDATA[" + this.text + "]]>";
        },
        initStuff() {

            this.showMore = "Show More";

            this.showLess = "Show Less";

            // if (this.lang === "da-DK") {
            //     this.showMore = "Vis Mere";

            //     this.showLess = "Vis Mindre";
            // }
            // else {
            //     this.showMore = "Show More";

            //     this.showLess = "Show Less";
            // }
        },
        toggleContent() {
            this.showContent = !this.showContent;
            this.containerHeight = this.showContent ? 'auto' : '0px';
        },
        expandText() {

            // if (this.expanded === false) {
            //     this.$refs.largeTextCon.style.maxHeight = "38px";
            // }
            // else {
            //     this.$refs.largeTextCon.style.maxHeight = "500px";
            // }

            this.expanded = !this.expanded;
        },
        // yolo() {

        //     // var icon = document.querySelector('#slider_desc_toogler > i');
        //     // icon.classList.toggle('fa-arrow-circle-down');
        //     // icon.classList.toggle('fa-arrow-circle-up');

        //     var descIcon = document.querySelector("#slider_desc_toogler > i");
        //     var sliderDesc = document.querySelector(".slider_desc");

        //     if (descIcon.classList.contains("fa-arrow-circle-down")) {
        //         sliderDesc.style.maxHeight = "38px";
        //     } else {
        //         sliderDesc.style.maxHeight = "500px";
        //     }
        // },

    },

};
</script>
<style scoped>
/* .container {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      transition: height 0.3s ease; 

    }
    .content {
      flex: 1; 
      transition: height 0.3s ease; 
    } */
.grid-container {
    display: grid;
    /* position: absolute; */
}

.content {

    position: relative;
    background: #373737;
    padding: 5px;
    border-radius: 10px;
    height: 58px;
    overflow: hidden;

    -webkit-transition: height 0.3s ease;
    /* Safari and Chrome */
    -moz-transition: height 0.3s ease;
    /* Firefox */
    -ms-transition: height 0.3s ease;
    /* IE */
    -o-transition: height 0.3s ease;
    /* Opera */
    transition: height 0.3s ease;
    /* Standard */
}

.expandButton {
    display: inline-block;
    position: absolute;
    bottom: 5px;
    right: 5px;

    background: #282727;
    border-radius: 10px;
}

/* span:hover+.grid-container .content {
    height: 100%;
} */

.expandedText {
    height: 100%;
}
</style>
